import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";

export const buttonTexts = {
  EXPORT_RECORD_BTN: "Export non synced Records",
  DOWNLOAD_BTN: "Download",
  SYNC_RECORDS_BTN: "Sync from QuickBooks",
};

export const filterNames = {
  CUSTOMER_FIELD: "customerFilter",
  JOB_FIELD: "jobFilter",
  MONTH_FIELD: "monthFilter",
};

export const filterList = ({
  customerOptions = [],
  jobOptions = [],
  monthOptions = [],
  customerSearch = "",
  jobSearch = "",
  monthSearch = "",
  setCustomerSearch = () => undefined,
  setJobSearch = () => undefined,
  setMonthSearch = () => undefined,
}) => {
  return [
    {
      type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
      name: "customerFilter",
      placeholder: "Select customer",
      bordered: true,
      options: customerOptions,
      setSearch: setCustomerSearch,
      searchValue: customerSearch,
    },
    {
      type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
      name: "jobFilter",
      placeholder: "Select job",
      bordered: true,
      options: jobOptions,
      setSearch: setJobSearch,
      searchValue: jobSearch,
    },
    {
      type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
      name: "monthFilter",
      placeholder: "Select month",
      bordered: true,
      options: monthOptions,
      setSearch: setMonthSearch,
      searchValue: monthSearch,
    },
  ];
};
